import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { authActions } from "./actions";
import { AuthState } from "./types";

const initialState: AuthState = {
  isLoggedIn: false,
  loggedInUser: null,
};

export function AuthReducer(state = initialState, action: Action): AuthState {
  if (isType(action, authActions.login.done)) {
    return {
      ...state,
      isLoggedIn: true,
    };
  }

  if (isType(action, authActions.setIsLoggedIn)) {
    return {
      ...state,
      isLoggedIn: action.payload,
      loggedInUser: action.payload ? state.loggedInUser : null,
    };
  }

  if (isType(action, authActions.getUser.done)) {
    return {
      ...state,
      isLoggedIn: true,
      loggedInUser: action.payload.result,
    };
  }

  if (isType(action, authActions.logout.done)) {
    return {
      ...state,
      isLoggedIn: false,
      loggedInUser: null,
    };
  }

  if (isType(action, authActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
